import { Variants, Variant } from 'framer-motion'

const slide = {
  initial: {
    y: '100%',
    opacity: 1,
  },
  in: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.2,
    },
  },
  out: {
    y: '100%',
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.2,
    },
  },
}

const scale = {
  initial: {
    scale: 0.95,
    opacity: 0,
  },
  in: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'ease-in',
      duration: 0.05,
    },
  },
  out: {
    scale: 0.95,
    opacity: 0,
    transition: {
      type: 'ease-in',
      duration: 0.05,
    },
  },
}

export const transition: Variants = {
  // No animation needed when coming directly to a modal route
  off: {
    scale: 1,
    opacity: 1,
    y: 0,
    transition: {
      duration: 0,
    },
  },
  // Use functions for dynamic variants based on screen size
  initial: (() => {
    if (typeof window !== 'undefined' && window.innerWidth < 640) {
      return slide.initial
    }
    return scale.initial
  }) as Variant,
  in: (() => {
    if (typeof window !== 'undefined' && window.innerWidth < 640) {
      return slide.in
    }
    return scale.in
  }) as Variant,
  out: (() => {
    if (typeof window !== 'undefined' && window.innerWidth < 640) {
      return slide.out
    }
    return scale.out
  }) as Variant,
}
